import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { ProblemSection } from './components/ProblemSection';
import { AuthoritySection } from './components/AuthoritySection';
import { DiagnosticSection } from './components/DiagnosticSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludedSection } from './components/IncludedSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { FaqSection } from './components/FaqSection';
import { PricingSection } from './components/PricingSection';
import { CloseSection } from './components/CloseSection';
import { WhatsAppProofSection } from './components/WhatsAppProofSection';
import { initPixel } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <main className="min-h-screen bg-cream font-sans text-charcoal selection:bg-terracotta-light selection:text-charcoal" data-id="element-0">
      <HeroSection data-id="element-1" />
      <IdentificationSection data-id="element-2" />
      <TestimonialsSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <AuthoritySection data-id="element-5" />
      <DiagnosticSection data-id="element-6" />
      <SolutionSection data-id="element-7" />
      <IncludedSection data-id="element-8" />
      <ResultsSection data-id="element-9" />
      <DifferentiatorSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <WhatsAppProofSection data-id="element-12" />
      <PricingSection data-id="element-13" />
      <CloseSection data-id="element-14" />
    </main>;
}